'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildStubbedThread = buildStubbedThread;

var _ThreadSources = require('conversations-schema/constants/ThreadSources');

var _buildConversation = require('conversations-schema/factories/ConversationFactory/buildConversation');

var _stubbedChannel = require('../constants/stubbedChannel');

function buildStubbedThread() {
  return (0, _buildConversation.buildConversation)({
    source: _ThreadSources.LIVE_CHAT,
    channel: _stubbedChannel.STUBBED_CHANNEL,
    threadId: null
  });
}


//////////////////
// WEBPACK FOOTER
// ./js/threads/factories/buildStubbedThread.js
// module id = 281
// module chunks = 2 3